/**
 * カラースキーム定義
 * プロジェクト全体で使用する色を一元管理
 */

// セマンティックカラー定義
export const semanticColors = {
  // アクションカラー（ユーザーアクションの結果）
  primary: {
    color: "text-blue-600",
    bg: "bg-blue-50",
  },
  secondary: {
    color: "text-gray-600",
    bg: "bg-gray-50",
  },

  // アラートカラー（システム状態の通知）
  success: {
    color: "text-green-600",
    bg: "bg-green-50",
  },
  info: {
    color: "text-blue-600",
    bg: "bg-blue-50",
  },
  warning: {
    color: "text-yellow-600",
    bg: "bg-yellow-50",
  },
  error: {
    color: "text-red-600",
    bg: "bg-red-50",
  },
} as const;

// Toast用のカラーマッピング
export const toastColorScheme = {
  primary: {
    color: semanticColors.primary.color,
    bg: semanticColors.primary.bg,
  },
  secondary: {
    color: semanticColors.secondary.color,
    bg: semanticColors.secondary.bg,
  },
  success: {
    color: semanticColors.success.color,
    bg: semanticColors.success.bg,
  },
  info: {
    color: semanticColors.info.color,
    bg: semanticColors.info.bg,
  },
  warning: {
    color: semanticColors.warning.color,
    bg: semanticColors.warning.bg,
  },
  error: {
    color: semanticColors.error.color,
    bg: semanticColors.error.bg,
  },
} as const;

// 型定義
export type SemanticColorKey = keyof typeof semanticColors;
export type ToastVariant = keyof typeof toastColorScheme;
